import { SiteWithPhotoModel } from "../../shared/models/site-with-photo.model";

export class SiteItemModel extends SiteWithPhotoModel {

  constructor(public id: string,
              public name: string,
              public address: string,
              public isOffline: boolean,
              public numberOfAnnotations: number,
              public isGraphic: boolean,
              public isExported: boolean,
              public numberOfExportedBuildings: number,
              public numberOfBuildings: number) {
    super(id);
  }
}
